import { previewShouldShowPostPurchaseChanges } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import paymentCheckoutExperiments from 'bundles/epic/clients/paymentCheckout';
import paymentsBackendEpicClient from 'bundles/epic/clients/payments-backend';
import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import type ValidPaymentProcessorsV1 from 'bundles/naptimejs/resources/validPaymentProcessors.v1';
import {
  googleCourseListForStripeRollout,
  stripeRolloutCourseListIncludingGoogle,
} from 'bundles/payments/common/stripeRolloutCourseList';

export const isStripeSubscriptionPaymentsCheckoutFlow = () =>
  paymentCheckoutExperiments.preview('enableStripeSubscriptionNewCheckoutFlow');

export const isStripeBillingEngineEnabled = (cart: CartsV2, validPaymentProcessors: ValidPaymentProcessorsV1) =>
  cart.isSubscription &&
  validPaymentProcessors.isPaypalEnabled &&
  paymentCheckoutExperiments.preview('enableStripeBillingEngine');

export const isStripeBillingEngineRazorpayEnabled = (cart: CartsV2, validPaymentProcessors: ValidPaymentProcessorsV1) =>
  cart.isSubscription &&
  validPaymentProcessors.isRazorpayEnabled &&
  (paymentCheckoutExperiments.get('enableStripeBillingEngineRazorpay') ||
    paymentCheckoutExperiments.get('enableStripeBillingEngineRazorpayAB'));

export const isStripeBillingEngineRazorpayABEnabledPreview = (cart: CartsV2) =>
  cart.isSubscription && paymentCheckoutExperiments.preview('enableStripeBillingEngineRazorpayAB');

export const isBillingEngineRazorpayUIEnabled = () =>
  paymentCheckoutExperiments.preview('enableStripeBillingEngineRazorpay');

export const isStripeWalletEnabled = () => paymentsBackendEpicClient.preview('enableSavedPaymentMethods');

const defaultPaymentMethodConfiguration = {
  stripeBvConsumer: 'pmc_1PC76EAEXNY2zYJrBbgPAPqB',
  stripeBvConsumerSandbox: 'pmc_1OyfCuAEXNY2zYJrm0Lbt9Fv',
  stripeConsumerSandbox: 'pmc_1PC3SwBEfO1jc2fnBE9wxPjn',
  stripeConsumer: 'pmc_1PqdhUBEfO1jc2fn2Y31iEKB',
};

export const isKlarnaEnabled = () => {
  return (
    paymentsBackendEpicClient.preview('stripeSubscriptionPaymentMethodConfig').stripeConsumer !==
    defaultPaymentMethodConfiguration.stripeConsumer
  );
};

export const isPixEnabled = (cart: CartsV2) => {
  return cart.isVC && cart.currencyCode === 'BRL' && paymentsBackendEpicClient.preview('enablePIX');
};

export const getStripePaymentMethodConfiguration = (isSandboxEnabled?: boolean, isRouteToStripeBv?: boolean) => {
  const paymentMethodConfiguration =
    paymentsBackendEpicClient.preview('stripeSubscriptionPaymentMethodConfig') || defaultPaymentMethodConfiguration;
  if (isRouteToStripeBv) {
    return isSandboxEnabled
      ? paymentMethodConfiguration.stripeBvConsumerSandbox
      : paymentMethodConfiguration.stripeBvConsumer;
  } else {
    return isSandboxEnabled
      ? paymentMethodConfiguration.stripeConsumerSandbox
      : paymentMethodConfiguration.stripeConsumer;
  }
};

export const getIsCourseUpsellOnStripeEligible = (cart: CartsV2) => {
  const isProductItemIdEligible =
    !stripeRolloutCourseListIncludingGoogle.includes(cart.productItemId) ||
    (previewShouldShowPostPurchaseChanges() && googleCourseListForStripeRollout.includes(cart.productItemId));
  return (
    cart.isVC && !cart.hasDiscount && !cart.isForGuidedProject && !cart.isForSelfPacedProject && isProductItemIdEligible
  );
};
